import React, { Suspense } from 'react';
import { Dialog } from '@tencent/spaui';
import uuid from 'uuid/v4';

import commonReport from '@/common/common-report.js';


export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    // console.error(error, info);
    const trace_id = uuid();
    if (error) {
      commonReport.reportCrash({ error, trace_id });
      this.setState({
        trace_id,
      });
    }
  }

  handleClose = () => {
    window.location.reload();
  }

  render() {
    const { hasError, trace_id } = this.state;
    if (hasError) {
      return (
        <Dialog
          useNewUI
          show={true}
          title="错误提示"
          type="normal"
          size="large"
          backdrop
          enabledBackdropClose
          closeButton={false}
          onClose={this.handleClose}
        >
          <div className="dialog-err">
            <span>客户端运行出错，请刷新页面重试或联系管理员反馈</span>
            <span>{`错误提示码：${trace_id}`}</span>
          </div>
        </Dialog>
      );
    }

    return this.props.children;
  }
}
